import { useState } from 'react';
import { Platform, SafeAreaView, View, StyleSheet } from 'react-native';
import { Text } from '@/components/Text';
import ConfirmModal from '@/components/SharedComponents/ConfirmModal/ConfirmModal';
import colors from '@/config/colors';
import { updateConsent } from '../../utils/consents';
import { styles } from './styles';
import {
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';

export function DigaMessages({
  isModalVisible,
  setModalVisible,

  isDeactivationPostponeConsentModalVisible,
  setDeactivationPostponeConsentModalVisible,

  isModalErrorVisible,
  setModalErrorVisible,

  isModalErrorAPIVisible,
  setModalErrorAPIVisible,

  isModalInternetErrorVisible,
  setModalInternetErrorVisible,

  consentId,
}) {
  const errorCodeText =
    'Bitte überprüfen Sie den Rezeptcode und versuchen Sie es erneut. ' +
    'Probleme beim Einlösen? Bitte melden Sie sich unter +49 (0)89 24886 4440 oder per E-mail an ';

  const internetErrorText =
    'Keine Verbindung zum neolexon Server. ' +
    'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. ' +
    '\n' +
    'Wenn das Problem besteht, melden Sie sich unter +49 (0)89 24886 4440 oder per E-mail an ';

  const email = 'info@neolexon.de';

  const deactivationPostponeConsentErrorText =
    'Die Einwilligung konnte nicht aktualisiert werden. Bitte versuchen Sie es später erneut. Sie finden die Einwillung zur späteren Account-Deaktivierung auch in Ihrem Nutzeraccount.';
  const [deactivationPostponeError, setDeactivationPostponeError] =
    useState('');

  const responsiveFontSize = useResponsiveFontSize(1);
  const responsiveHeight = useResponsiveHeight(100);

  const isFullscreen = Platform.OS !== 'web' && responsiveHeight < 500;

  const getResponsiveFontSize = (factor) => responsiveFontSize * factor;

  let responsiveStyles = StyleSheet.create({
    successText: {
      fontSize: isFullscreen
        ? getResponsiveFontSize(2.2)
        : getResponsiveFontSize(1.9),
      color: colors.green,
      marginVertical: getResponsiveFontSize(0.5),
    },
    instructions: {
      fontSize: isFullscreen
        ? getResponsiveFontSize(2.1)
        : getResponsiveFontSize(1.7),
      marginVertical: getResponsiveFontSize(0.5),
    },
    errorText: {
      fontSize: isFullscreen
        ? getResponsiveFontSize(2.0)
        : getResponsiveFontSize(1.7),
      color: colors.red,
      marginVertical: getResponsiveFontSize(0.5),
    },
    container: { padding: useResponsiveWidth(2.4) },
  });

  async function updateDeactivationPostponeConsent(isConsentGiven) {
    try {
      if (consentId) {
        await updateConsent(consentId, isConsentGiven);
        return true;
      }
      return false;
    } catch (_error) {
      return false;
    }
  }

  return (
    <SafeAreaView>
      <ConfirmModal
        isVisible={isModalVisible}
        headerText={'Rezeptcode eingelöst'}
        contentText={'Ihr Rezeptcode wurde erfolgreich eingelöst.'}
        confirmText={'OK'}
        confirmAction={() => {
          setModalVisible(false);
        }}
        customHeight={15}
      />

      <ConfirmModal
        isVisible={isDeactivationPostponeConsentModalVisible}
        isFullscreen={isFullscreen}
        headerText={'Einwilligung zur Verlängerung der Account-Deaktivierung'}
        confirmAction={async () => {
          if (await updateDeactivationPostponeConsent(true)) {
            return setDeactivationPostponeConsentModalVisible(false);
          }
          setDeactivationPostponeError(deactivationPostponeConsentErrorText);
        }}
        cancelAction={async () => {
          await updateDeactivationPostponeConsent(false);
          setDeactivationPostponeConsentModalVisible(false);
        }}
        isContentComponent
        contentText={
          <View style={responsiveStyles.container}>
            <Text style={responsiveStyles.successText}>
              Ihr Rezeptcode wurde erfolgreich eingelöst.
            </Text>
            <Text style={responsiveStyles.instructions}>
              Ich willige ein, dass mein Account mit meinen Daten nach Ablauf
              der 90-tägigen Nutzungsdauer des Rezeptcodes für weitere 30 Tage
              bestehen bleibt. Auf diese Weise habe ich 30 Tage länger Zeit, bei
              Bedarf einen weiteren Rezeptcode direkt einzulösen und meinen
              Account weiterzunutzen. Sollte nach der Verlängerung von 30 Tagen
              kein Rezeptcode eingelöst worden sein, wird mein Account aufgrund
              von gesetzlichen Bestimmungen deaktiviert. Nach der Deaktivierung
              kann ich jederzeit eine Reaktivierung beantragen. Ich kann meine
              Einwilligung jederzeit widerrufen. Die Einwilligung ist optional.
            </Text>
            {!!deactivationPostponeError && (
              <Text style={responsiveStyles.errorText}>
                {deactivationPostponeError}
              </Text>
            )}
          </View>
        }
        confirmText={'Ich willige ein'}
        cancelText={'Account unmittelbar nach Ablauf des Codes deaktivieren'}
      />

      <ConfirmModal
        isVisible={isModalErrorVisible}
        headerText={'Ungültiger Rezeptcode'}
        customHeight={35}
        contentText={[
          errorCodeText,
          email && (
            <Text style={styles.emailPopUp} key={'email'}>
              {email}
            </Text>
          ),
        ]}
        confirmText={'OK'}
        confirmAction={() => setModalErrorVisible()}
      />

      <ConfirmModal
        isVisible={isModalErrorAPIVisible}
        headerText={'Ungültiger Rezeptcode'}
        customHeight={35}
        contentText={[
          errorCodeText,
          email && (
            <Text style={styles.emailPopUp} key={'email'}>
              {email}
            </Text>
          ),
        ]}
        confirmText={'OK'}
        confirmAction={() => setModalErrorAPIVisible(false)}
      />

      <ConfirmModal
        isVisible={isModalInternetErrorVisible}
        headerText={'Fehler bei Einlösen des Rezeptcodes'}
        customHeight={35}
        contentText={[
          internetErrorText,
          <Text style={styles.emailPopUp} key={'email'}>
            {email}
          </Text>,
        ]}
        confirmText={'OK'}
        confirmAction={() => {
          setModalInternetErrorVisible(false);
        }}
      />
    </SafeAreaView>
  );
}
